module.exports = __webpack_public_path__ + "img/running.229ec062.png";